import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Row, Col, Container, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import api from "../api/axios";
import "../assets/css/Waitinglist.css";
import { useNavigate } from "react-router-dom";
import logo from "../assets/images/Shaadilogo.png";
import shap from "../assets/images/shape1.png";
import ComingsoonFooter from "../components/ComingsoonFooter";
const Waitlist = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        city: "",
    });

    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [alreadySubmitted, setAlreadySubmitted] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [launchDate, setLaunchDate] = useState(null);
    const [timeLoading, setTimeLoading] = useState(true);
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);

    const getTime = () => {
        if (!launchDate) {
            return { days: 0, hours: 0, minutes: 0, seconds: 0 };
        }

        const now = new Date().getTime();
        const diff = new Date(launchDate).getTime() - now;

        return {
            days: Math.max(0, Math.floor(diff / (1000 * 60 * 60 * 24))),
            hours: Math.max(0, Math.floor((diff / (1000 * 60 * 60)) % 24)),
            minutes: Math.max(0, Math.floor((diff / (1000 * 60)) % 60)),
            seconds: Math.max(0, Math.floor((diff / 1000) % 60)),
        };
    };

    const [timeLeft, setTimeLeft] = useState(getTime());

    useEffect(() => {
        const fetchWaitlistTime = async () => {
            setTimeLoading(true);

            try {
                const res = await api.get("/waitlistRoutes/public/waitlist-time");

                if (res.data?.success && res.data?.data?.launch_at) {
                    setLaunchDate(res.data.data.launch_at);
                } else {
                    toast.error("Launch time not found.");
                }
            } catch (error) {
                console.error("Failed to fetch waitlist time:", error);
                toast.error("Unable to fetch launch time.");
            } finally {
                setTimeLoading(false);
            }
        };

        fetchWaitlistTime();
    }, []);

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(getTime());
        }, 1000);

        return () => clearInterval(timer);
    }, [launchDate]);

    const handleChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
        setErrors((prev) => ({ ...prev, [field]: "" }));
    };

    const validate = () => {
        const err = {};

        if (!formData.name.trim()) err.name = "Name is required";

        if (!formData.phone) err.phone = "Phone is required";
        else if (formData.phone.length !== 10)
            err.phone = "Enter valid 10 digit number";

        if (!formData.email) err.email = "Email is required";
        else if (!/^\S+@\S+\.\S+$/.test(formData.email))
            err.email = "Enter valid email";

        if (!formData.city.trim()) err.city = "City is required";

        setErrors(err);
        return Object.keys(err).length === 0;
    };

    const resetForm = () => {
        setFormData({
            name: "",
            phone: "",
            email: "",
            city: "",
        });
        setErrors({});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (submitting) return;
        if (!validate()) return;

        setSubmitting(true);

        try {
            const res = await api.post("/waitlistRoutes/public/join", {
                name: formData.name.trim(),
                phone: formData.phone.trim(),
                email: formData.email.trim(),
                city: formData.city.trim(),
            });

            if (res.data?.success) {
                setSubmitted(true);
                setAlreadySubmitted(false);
                setShowForm(false);
                setShowSuccessPopup(true);
                resetForm();
            }
        } catch (error) {
            const status = error?.response?.status;
            const message =
                error?.response?.data?.message || "Something went wrong. Please try again.";

            if (status === 409) {
                setSubmitted(true);
                setAlreadySubmitted(true);
                setShowForm(false);
                setShowSuccessPopup(true);
            } else {
                toast.error(message);
            }
        } finally {
            setSubmitting(false);
        }
    };

    /*------------ 🔥 AUTO OPEN Envelop------------*/

    const [open, setOpen] = useState(false);

    // useEffect(() => {
    //     const timer = setTimeout(() => {
    //     setOpen(true);
    //     }, 500); // delay after page load

    //     return () => clearTimeout(timer);
    // }, []);

    return (
        <>
            <section
                style={{
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    textAlign: "center",
                }}
                className="category-part animate"
            >
                <div className="fxt-shape">
                    <div className="fxt-transformX-L-50 fxt-transition-delay-1">
                        <img src={shap} alt="shape" />
                    </div>
                </div>

                <Container>
                    <Row className="mx-0 breadcrumb_part align-items-center justify-content-center">
                        <Col lg={6} className="watlistborder">
                            <div className="w-100 text-center">
                                <img src={logo} alt="Shaadi Material" style={{ height: "125px" }} />

                                <h2 className="mt-5 text-white">Join Our Exclusive Waitlist</h2>

                                <p style={{ color: "#757575" }}>
                                    Be among the first to experience our upcoming platform.
                                    <br />
                                    Sign up today and get early access, priority updates, and exclusive benefits.
                                </p>
                            </div>

                            <div style={{ maxWidth: "550px", margin: "0 auto" }}>
                                {!showForm && !submitted && (
                                    <>
                                        {timeLoading ? (
                                            <div className="vertical-countdown">
                                                {[1, 2, 3, 4].map((item) => (
                                                    <div className="v-box" key={item}>
                                                        <span>
                                                            <i className="pi pi-spin pi-spinner" />
                                                        </span>
                                                        <p>Loading</p>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <div className="vertical-countdown">
                                                <div className="v-box">
                                                    <span>{timeLeft.days}</span>
                                                    <p>Days</p>
                                                </div>

                                                <div className="v-box">
                                                    <span>{timeLeft.hours}</span>
                                                    <p>Hours</p>
                                                </div>

                                                <div className="v-box">
                                                    <span>{timeLeft.minutes}</span>
                                                    <p>Minutes</p>
                                                </div>

                                                <div className="v-box">
                                                    <span>{timeLeft.seconds}</span>
                                                    <p>Seconds</p>
                                                </div>
                                            </div>
                                        )}

                                        <Button
                                            className="py-2 w-100 d-block mt-4 custbuttonpink"
                                            onClick={() => setShowForm(true)}
                                            label={timeLoading ? "Loading..." : "Join Waitlist"}
                                            disabled={timeLoading}
                                        />
                                    </>
                                )}

                                {showForm && !submitted && (
                                    <form
                                        onSubmit={handleSubmit}
                                        className="p-fluid prof_content user-dash"
                                        style={{ margin: "30px auto", maxWidth: "400px" }}
                                    >
                                        <div className="mb-3 text-start">
                                            <label>Name *</label>
                                            <InputText
                                                value={formData.name}
                                                onChange={(e) => handleChange("name", e.target.value)}
                                                className={errors.name ? "p-invalid w-100" : "w-100"}
                                                disabled={submitting}
                                            />
                                            {errors.name && <small className="p-error">{errors.name}</small>}
                                        </div>

                                        <div className="mb-3 text-start">
                                            <label>Phone *</label>
                                            <InputText
                                                value={formData.phone}
                                                onChange={(e) => {
                                                    const val = e.target.value.replace(/\D/g, "").slice(0, 10);
                                                    handleChange("phone", val);
                                                }}
                                                className={errors.phone ? "p-invalid w-100" : "w-100"}
                                                disabled={submitting}
                                            />
                                            {errors.phone && <small className="p-error">{errors.phone}</small>}
                                        </div>

                                        <div className="mb-3 text-start">
                                            <label>Email *</label>
                                            <InputText
                                                type="email"
                                                value={formData.email}
                                                onChange={(e) => handleChange("email", e.target.value)}
                                                className={errors.email ? "p-invalid w-100" : "w-100"}
                                                disabled={submitting}
                                            />
                                            {errors.email && <small className="p-error">{errors.email}</small>}
                                        </div>

                                        <div className="mb-3 text-start">
                                            <label>City *</label>
                                            <InputText
                                                value={formData.city}
                                                onChange={(e) => handleChange("city", e.target.value)}
                                                className={errors.city ? "p-invalid w-100" : "w-100"}
                                                disabled={submitting}
                                            />
                                            {errors.city && <small className="p-error">{errors.city}</small>}
                                        </div>

                                        <Button
                                            type="submit"
                                            label={submitting ? "Joining..." : "Join Waitlist"}
                                            icon={submitting ? "pi pi-spin pi-spinner" : undefined}
                                            disabled={submitting}
                                            className="py-2 w-100 d-block mt-4 custbuttonpink"
                                        />
                                    </form>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <Modal
                show={showSuccessPopup}
                onHide={() => setShowSuccessPopup(false)}
                centered
                className="waitlist-envelope-modal"
                 dialogClassName="waitlist-envelope-modal"
                onEntered={() => setOpen(true)}   // 🔥 TRIGGER HERE
                onExit={() => setOpen(false)} 
            >
                <Modal.Body className="bg-black">
                    {/* <div className="envelope-popup">
                        <div className="envelope">
                            <div className="envelope-flap" />
                            <div className="envelope-body" />

                            <div className="letter">
                                <img src={logo} alt="Shaadi Material" />

                                {alreadySubmitted ? (
                                    <>
                                        <h3>You're already on the list</h3>
                                        <p>
                                            Looks like you have already joined the Shaadi Material waitlist.
                                            We’ll notify you as soon as access opens.
                                        </p>
                                    </>
                                ) : (
                                    <>
                                        <h3>You're on the list</h3>
                                        <p>
                                            Thank you for joining the Shaadi Material waitlist. Your confirmation
                                            email is on its way.
                                        </p>
                                    </>
                                )}

                                <Button
                                    label="Lovely"
                                    className="custbuttonpink mt-3"
                                    onClick={() => setShowSuccessPopup(false)}
                                />
                            </div>
                        </div>
                    </div> */}
                    <div className={`envwrapper ${open ? "open" : ""}`}>
                        <div className="lid one"></div>
                        <div className="lid two"></div>
                        <div className="envelope"></div>
                        <div className="letter">
                            <img src={logo} alt="Shaadi Material" />
                            {alreadySubmitted ? (
                                <>
                                    <h3>You're already on the list</h3>
                                    <p>
                                        Looks like you have already joined the Shaadi Material waitlist.
                                        We’ll notify you as soon as access opens.
                                    </p>
                                </>
                            ) : (
                                <>
                                    <h3>You're on the list</h3>
                                    <p>
                                        Thank you for joining the Shaadi Material waitlist. Your confirmation
                                        email is on its way.
                                    </p>
                                </>
                            )}

                            <Button
                                icon="pi pi-times"
                                className="py-1 zind"
                                style={{ fontSize: "14px" }}
                                 onClick={() => {
                                    setShowSuccessPopup(false);
                                    navigate("/"); // 🔥 go to home page
                                }}
                                text
                                
                            />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <ComingsoonFooter />
        </>
    );
};

export default Waitlist;